// This is just for the Loading or Error Selector
export const GET_CLAIMS = "GET_CLAIMS";

export const GET_CLAIMS_REQUEST = "GET_CLAIMS_REQUEST";
export const GET_CLAIMS_SUCCESS = "GET_CLAIMS_SUCCESS";
export const GET_CLAIMS_ERROR = "GET_CLAIMS_ERROR";


